import React from "react";
import { observer } from "mobx-react-lite";
import { Col, Form, Row } from "react-bootstrap";
import type { ViewComponent } from "@frui.ts/views";
import FakeInput from "@edaz/edazkit/controls/FakeInput";
import { formatAmount, formatDateTime } from "../../../../utils/localizations";
import type TransferRefundForRefundOfRefundsDetailViewModel from "viewModels/finance/refundForRefundOfRefunds/transferRefundForRefundOfRefunds/transferRefundForRefundOfRefundsDetailViewModel";
import Section from "../../../common/section";

const OrderSectionView: ViewComponent<TransferRefundForRefundOfRefundsDetailViewModel> = observer(({ vm }) => (
  <Section title={vm.translate("order.title")} context={vm.item.charge}>
    <Row>
      <Form.Group as={Col} sm={12} md={4} xl="auto" className="mb-3" style={{ flexGrow: "1", maxWidth: "100%" }}>
        <Form.Label>{vm.translateModelAttribute("charge", "vehicle")}</Form.Label>
        <FakeInput
          target={vm.item.charge ? vm.item.charge.vehicle : undefined}
          property="licensePlate"
          valueFormatter={(licensePlate: string) =>
            licensePlate && vm.item.charge
              ? `${vm.countryCode(vm.item.charge.vehicle.countryId)} - ${licensePlate}`.replace(/ /g, "\u00a0")
              : undefined
          }
        />
      </Form.Group>
      <Form.Group as={Col} sm={12} md={4} xl="auto" className="mb-3" style={{ flexGrow: "1", maxWidth: "100%" }}>
        <Form.Label>{vm.translateModelAttribute("charge", "chargeTypeId")}</Form.Label>
        <FakeInput
          target={vm.item.charge}
          property="priceListItemId"
          valueFormatter={(priceListItemId: string) => vm.chargeType(priceListItemId)}
        />
      </Form.Group>
      <Form.Group as={Col} sm={12} md={4} xl="auto" className="mb-3" style={{ flexGrow: "1", maxWidth: "100%" }}>
        <Form.Label>{vm.translateModelAttribute("charge", "price")}</Form.Label>
        <FakeInput target={vm.item.charge} property="price" valueFormatter={(price: number) => formatAmount(price)} />
      </Form.Group>
      <Form.Group as={Col} sm={12} md={6} xl={3} className="mb-3">
        <Form.Label>{vm.translateModelAttribute("charge", "validSince")}</Form.Label>
        <FakeInput target={vm.item.charge} property="validSince" valueFormatter={(date: Date) => formatDateTime(date)} />
      </Form.Group>
      <Form.Group as={Col} sm={12} md={6} xl={3} className="mb-3">
        <Form.Label>{vm.translateModelAttribute("charge", "validUntil")}</Form.Label>
        <FakeInput target={vm.item.charge} property="validUntil" valueFormatter={(date: Date) => formatDateTime(date)} />
      </Form.Group>
    </Row>
  </Section>
));

export default OrderSectionView;
